var _require = require('@antv/component/lib'),
    Guide = _require.Guide;

var RegionFilter = require('./region-filter');

Guide.RegionFilter = RegionFilter;
module.exports = Guide;


//////////////////
// WEBPACK FOOTER
// ./src/component/guide/index.js
// module id = 407
// module chunks = 0 1 2